import { func, shape } from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import * as Actions from 'Redux/modules/webChat/actions';
import { getHealthSummaryById } from 'Selectors/webChat/healthSummary';
import { Icon, Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../../ContextMenuHeader';

import SummaryDetails from './SummaryDetails';

class Summary extends Component {
  componentDidMount() {
    this.getDetailHealthSummary();
  }

  getDetailHealthSummary = () => {
    const {
      getHealthSummary,
      consult: { healthSummary },
      doctor: { id },
    } = this.props;
    if (healthSummary.length > 0) {
      getHealthSummary({
        doctorId: id,
        summaryId: healthSummary[0].healthSummaryId,
      });
    }
  };

  render() {
    const {
      healthSummary: {
        status: { loading },
      },
      consult: { healthSummary },
      goBack,
      getHealthSummaryById, // eslint-disable-line
    } = this.props;
    const initValueHealthSummary =
      healthSummary.length > 0 ? getHealthSummaryById(healthSummary[0].healthSummaryId) : undefined;
    return (
      <Segment.Group className="context-menu history summary">
        <ContextMenuHeader title="Summary Details" goBack={goBack} />
        <Segment className="body">
          {loading === 0 ? (
            <Segment basic textAlign="center">
              <Icon name="spinner" size="big" loading />
              <span>Loading</span>
            </Segment>
          ) : (
            <SummaryDetails healthSummary={initValueHealthSummary} />
          )}
        </Segment>
      </Segment.Group>
    );
  }
}

Summary.propTypes = {
  goBack: func.isRequired,
  getHealthSummary: func.isRequired,
  getHealthSummaryById: func.isRequired,
  healthSummary: shape({}).isRequired,
  consult: shape({}).isRequired,
  doctor: shape({}).isRequired,
};

Summary.defaultProps = {};

const mapStateToProps = state => ({
  getHealthSummaryById: id => getHealthSummaryById(state, id),
  healthSummary: state.webChat.healthSummary,
});
const mapDispatchToProps = {
  getHealthSummary: Actions.healthSummaryRetrieve,
};

export default connect(mapStateToProps, mapDispatchToProps)(Summary);
